import { useTranslation } from "src/hooks";
import { useBatchContractSweepFormContext } from "../../../contexts";
import WalletVersionSelection from "src/components/Common/WalletVersionSelection/WalletVersionSingleSelection";
import EnumWalletType from "@wallet-manager/node-types/dist/types/postgres/const/WalletType";

function WalletVersionSingleSelection() {
  const {
    translate: t,
    fields,
    setFields,
    previewParams,
  } = useBatchContractSweepFormContext();

  const { tc } = useTranslation("common");
  const label = t("wallet_version");

  return (
    <>
      <div>{label}</div>
      <WalletVersionSelection
        customLabel={tc("phSelection", { fieldName: label })}
        value={fields.walletVersion}
        onChange={(walletVersion) =>
          setFields((f) => ({ ...f, walletVersion }))
        }
        // walletEnableStatus={}
        // chainId={Number(previewParams.chainId)}
        // smartAccountType={previewParams.smartAccountType}
        chainType={Number(previewParams.chainType)}
        walletTypes={[EnumWalletType.ClientWallet]}
      />
    </>
  );
}

export default WalletVersionSingleSelection;
